import { render, staticRenderFns } from "./ServiceTerms.vue?vue&type=template&id=aad723fa&scoped=true"
import script from "./ServiceTerms.vue?vue&type=script&lang=js"
export * from "./ServiceTerms.vue?vue&type=script&lang=js"
import style0 from "./ServiceTerms.vue?vue&type=style&index=0&id=aad723fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aad723fa",
  null
  
)

export default component.exports